import React from 'react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { SubmitFormOnPipe, WhenModelValue } from '@morningtrain/react-resources'

function SaveOrderAsDraft (props) {
  return (
    <WhenModelValue name='status' condition={s => !s || ['draft'].includes(s)}>
      <Auth.Can permission='api.inventory.order.store'>
        <Pipeline>
          <TriggerPipelineOnClick>
            <Button color='white'>
              <Translation name='actions.save_draft' />
            </Button>
          </TriggerPipelineOnClick>
          <SubmitFormOnPipe data={{ status: 'draft' }} />
        </Pipeline>
      </Auth.Can>
    </WhenModelValue>
  )
}

export default SaveOrderAsDraft
